import { baseDateValues } from './settings';
import CustomDate from './CustomDate';

// Tarih hesaplama yardımcı fonksiyonu
export default function getCustomDate( scrollPosition, interval) {


  // ScrollPosition'ın sayı olduğundan emin olalım
  if (typeof scrollPosition !== 'number') {
    scrollPosition = Number(scrollPosition) || 0;
  }
  
  // Interval'ın doğru formatta olduğundan emin olalım
  let intervalValue = 'day'; // Varsayılan
  let pixelWidth = 100; // Varsayılan
  
  if (interval) {
    intervalValue = interval.value || 'day';
    pixelWidth = interval.pixelWidth || 100;
  }

  const baseDatee = new CustomDate(baseDateValues.year,baseDateValues.month, baseDateValues.day);
  
  // scrollPosition / pixelWidth = kaçıncı interval'dayız
  const intervalsFromStart = Math.floor(scrollPosition / pixelWidth);

  // Doğrudan addIntervals fonksiyonunu kullanarak intervalleri ekle
  const result = baseDatee.addIntervals(intervalsFromStart, intervalValue);

  return result;
} 